var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.388 22.2248C32.049 22.2248 31.724 22.3594 31.4843 22.5991L22.9415 31.1418C21.9433 32.14 21.9433 33.7584 22.9415 34.7566L29.2263 41.0413C30.2245 42.0395 31.8428 42.0395 32.841 41.0413L41.3838 32.4986C41.6235 32.2589 41.7581 31.9338 41.7581 31.5949L41.7581 24.404C41.7581 24.0651 41.6235 23.74 41.3838 23.5004L40.4825 22.5991C40.2428 22.3594 39.9178 22.2248 39.5788 22.2248L32.388 22.2248ZM35.983 28.0003C36.6664 28.6837 37.7744 28.6837 38.4579 28.0003C39.1413 27.3169 39.1413 26.2088 38.4579 25.5254C37.7744 24.842 36.6664 24.842 35.983 25.5254C35.2996 26.2088 35.2996 27.3169 35.983 28.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.e64bab59ca8d9989bbc18c40f8afdaa8.svg";
export { ForwardRef as ReactComponent };